const FixtureMapping = {
    home_team_id: 'homeId',
    home_team_name: 'homeName',
    matchdate_ist: 'matchDate',
    match_status: 'matchStatus',
    match_stage: 'matchStage',
};

export { FixtureMapping }